export default function NotFound() {
  return (
    <div style={{ color: "#fff", textAlign: "center", padding: "80px 20px", background: "#08080d", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div>
        <h1 style={{ fontFamily: "Orbitron, sans-serif", fontSize: 48, color: "#FF1C35" }}>404</h1>
        <p style={{ color: "rgba(255,255,255,0.5)", marginTop: 16 }}>Page not found</p>
      </div>
    </div>
  );
}
